import { useQuery } from '@tanstack/react-query'
import type { GetInquiryRoleMembersParams } from '@/lib'
import { getInquiryRoleMembers } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

type UseInquiryRoleMembersOptions = GetInquiryRoleMembersParams & {
  enabled?: boolean
}

/**
 * 引合ロールメンバー一覧を取得するフック
 * isSales/isSmg/isManager フラグで取得ロールを絞り込める。
 * 未指定時は全ロール（sales/smg/manager）を返す。
 */
export function useInquiryRoleMembers(options: UseInquiryRoleMembersOptions = {}) {
  const { isSales, isSmg, isManager, offset, limit, enabled = true } = options

  return useQuery({
    queryKey: queryKeys.inquiryRoleMembers({ isSales, isSmg, isManager, offset, limit }),
    queryFn: async () => {
      return getInquiryRoleMembers({ isSales, isSmg, isManager, offset, limit })
    },
    enabled,
  })
}
